import { singleton } from 'tsyringe';
import { EventEmitter2 } from 'eventemitter2';

@singleton()
export class PublicEventEmitterService{
  emitter: EventEmitter2;

  constructor(){
    this.emitter = new EventEmitter2({
        wildcard: true,
        delimiter: ':',
      }
    );
  }
  on (event: string, callback: ()=>void) {
    return this.emitter.on(event, callback);
  }
}
